module.exports = __webpack_public_path__ + "img/ystar.3d598db6.png";